import routes from '@/modules/profile/profile-routes';
import store from '@/modules/profile/profile-store';
export default {
    components: [],
    routes,
    store,
};
